import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Trader {

  code: string | undefined;

  originCode?: string | undefined;

  description: string | undefined;

  initials: string | undefined;

  modificationDate?: DateTime = DateTime.now();

  userName?: string | undefined;

}
